// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';
import { ProductCard } from '../../../components/NewCard/types';
import { PaginationListResponse, SearchCondition } from '../../../types/Model';

export interface searchExamsRequestPayload {
  limit: number;
  page: number;
  condition: SearchCondition;
}

export type searchExamsSuccessPayload = PaginationListResponse<ProductCard>;

export interface searchExamsFailPayload {
  error: Error;
}

export const searchExamsActions = createAsyncAction(
  'elearning/SEARCH_EXAMS',
  'elearning/SEARCH_EXAMS_SUCCESS',
  'elearning/SEARCH_EXAMS_FAIL'
)<
  searchExamsRequestPayload,
  searchExamsSuccessPayload,
  searchExamsFailPayload
>();
